import { render, staticRenderFns } from "./AddPlan.vue?vue&type=template&id=12560e34"
import script from "./AddPlan.vue?vue&type=script&lang=ts"
export * from "./AddPlan.vue?vue&type=script&lang=ts"
import style0 from "./AddPlan.vue?vue&type=style&index=0&id=12560e34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports